import { format } from "date-fns";
import { DATE_TIME_FORMAT } from "@/constants/dateFormat";

export default function formatDateTime(
  input: string | number | Date,
  stringFormat: string = DATE_TIME_FORMAT
): string {
  if (!input) {
    return "";
  }
  return format(input, stringFormat);
}
